import { BASE_URL } from "@/config/index.js";
import { http } from "@/api/request.js";

export async function getMainCountryEvent(data = {}, config = {}) {
  return http.get(`${BASE_URL}ncov2020/getMainCountryEvent`, data, config);
}

export async function getSankeyList(data = {}, config = {}) {
  return http.get(`${BASE_URL}ncov2020/getForeignInputCase
  `, data, config);
}

export async function getTxUnifiedData(data = {}, config = {}) {
  return http.get(`https://dsf.nfapp.southcn.com/nfplus-ncov-api/ncov2019/getTxUnifiedData
  `, data, config);
}